import { Field } from 'react-final-form';
import Tooltip from 'react-tooltip-lite';
import CustomRadioButton from '../../../../components/form/CustomRadioButton';
import Icon from '../../../../assets/icons/Icon';
import { useDict } from '../../../../contexts/LanguageContext';

const MBAMMember = ({ submitted }) => {
    const dict = useDict();

    return (
        <span style={{ width: '100%' }}>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.isSophisticatedInvestor}
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                    <Tooltip
                        data-html="true"
                        content={
                            <div>
                                {dict.sophisticatedInvestorText}:
                                <ul>
                                    <li>{dict.highNetWorthInvestor}:
                                        <ul>
                                            <li>{dict.highNetWorthInvestorList1}</li>
                                            <li>{dict.highNetWorthInvestorList2}</li>
                                            <li>{dict.highNetWorthInvestorList3}</li>
                                        </ul>
                                    </li>
                                    <li>{dict.ultraHighNetWorthInvestor}</li>
                                    <ul>
                                        <li>{dict.ultraHighNetWorthInvestorList1}</li>
                                        <li>{dict.ultraHighNetWorthInvestorList2}</li>
                                        <li>{dict.ultraHighNetWorthInvestorList3}</li>
                                    </ul>
                                    <li>{dict.institutionalInvestor}:
                                        <ul>
                                            <li>{dict.institutionalInvestorList1}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        }
                        styles={{ display: 'inline' }}
                        distance={5}
                        arrowSize={8}
                    >
                        <Icon icon="InfoCircle" />
                    </Tooltip>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap">
                        <Field name="MBAM_Investor" type="radio" value="1">
                            {({ input, meta }) => (
                                <CustomRadioButton
                                    input={input}
                                    meta={meta}
                                    label={dict.yes}
                                    className="colored"
                                    submit={submitted}
                                    data-cy="MBAM_Investor__radio"
                                />
                            )}
                        </Field>
                        <Field name="MBAM_Investor" type="radio" value="0">
                            {({ input, meta }) => (
                                <CustomRadioButton
                                    input={input}
                                    meta={meta}
                                    label={dict.no}
                                    className="colored"
                                    submit={submitted}
                                // defaultChecked
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
        </span>
    );
};

MBAMMember.defaultProps = {
    submitted: false,
};

export default MBAMMember;
